import React, { Fragment, Suspense } from "react";
import { Route, Routes as Switch } from "react-router-dom";
import NoComponentFound from "../views/NoComponentFound";
import PATHS, { authenticationFlowPaths } from "../paths";
import RenderableView from "./RenderableView";
import withErrorBoundary from "../../Common/hocs/withErrorBoundary";
import AuthenticationComponent from "./AuthenticationComponent";
import { useLoginQuery } from "../../services/authorization/api";
import SplashPage from '../views/SplashPage';

function Routes() {
  const loginQuery = useLoginQuery();
  const isLoadingLoginInfo = loginQuery.isLoading || loginQuery.isFetching || !loginQuery.data?.name; // Check name make sure we have login data
  
  let RoutesToRender = PATHS.map((pathInformation, index) => (
    <Route
      key={`route${encodeURIComponent(pathInformation.title)}#${index}`}
      path={pathInformation.path}
      element={<RenderableView {...pathInformation} />}
    />
  ));

  return (
    <Fragment>
      { isLoadingLoginInfo ? <SplashPage /> :
      <Suspense fallback={<div>Loading</div>}>
        <Switch>
          {authenticationFlowPaths.map(({ path, ...rest }, index) => (
            <Route
              key={`route${encodeURIComponent(path)}#${index}`}
              path={path}
              element={<AuthenticationComponent {...rest} />}
            />
          ))}
          {RoutesToRender}
          <Route element={<NoComponentFound />} />
        </Switch>
      </Suspense>
      }
    </Fragment>
  );
}

/**
 * 
 * Authenticated
 * <Component1 />
 * <Component2 />
 */

export default withErrorBoundary(Routes);
